import { render, staticRenderFns } from "./PackScan.vue?vue&type=template&id=37f6e0d0&scoped=true&"
import script from "./PackScan.vue?vue&type=script&lang=js&"
export * from "./PackScan.vue?vue&type=script&lang=js&"
import style0 from "./PackScan.vue?vue&type=style&index=0&id=37f6e0d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6e0d0",
  null
  
)

export default component.exports